import styles from './Header.module.css';
import { NavLink } from 'react-router-dom';
import React from 'react';

function Header() {
  return (
    <div className={styles.header}>
      <div className={styles.atlas}></div>
    </div>
  );
}

export default Header;
